export enum QuotasEnum {
    Ocr = 'total_ocr_pages_count',
    SalesInvoiceCount = 'total_sales_invoices_count',
    SalesInvoiceAmount = 'total_sales_invoices_net_amount',
}